import { createTheme } from '@mui/material/styles';

// Modernized Milient purple. Single source of brand truth.
const PURPLE = '#6B46C1';
const PURPLE_DARK = '#553C9A';
const PURPLE_LIGHT = '#9F7AEA';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: PURPLE, dark: PURPLE_DARK, light: PURPLE_LIGHT, contrastText: '#fff' },
    secondary: { main: '#319795' },
    background: { default: '#f6f7fb', paper: '#ffffff' },
    success: { main: '#2F855A' },
    warning: { main: '#C05621' },
    error: { main: '#C53030' },
    text: { primary: '#1a202c', secondary: '#4a5568' }
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-0.5px' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.04)', borderRadius: 16 }
      }
    },
    MuiButton: { styleOverrides: { root: { borderRadius: 10 } } },
    MuiAppBar: {
      styleOverrides: { root: { backgroundImage: 'none' } }
    }
  }
});

export default theme;
